<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title>
          การตั้งเงื่อนไข <v-spacer></v-spacer
          ><v-btn color="primary" text @click="collapse = !collapse">{{
            !collapse ? "แสดงเงื่อนไข" : "ซ่อนการแสดงเงื่อนไข"
          }}</v-btn></v-card-title
        >
        <v-card-text class="black--text"
          ><h4>คำถาม - {{ QuestionTextShow(LastQuestion) }}</h4></v-card-text
        >
        <v-expand-transition>
          <v-card
            flat
            color="transparent"
            v-show="collapse"
            :disabled="!editable"
          >
            <v-card-text class="py-0">
              <v-spacer></v-spacer>
              <v-select
                v-model="condition_selected.conditiontype"
                :items="conditiontypeitem"
                item-text="text"
                item-value="value"
                dense
                label="รูปแบบเงื่อนไข"
                outlined
                :disabled="enableConditionChange"
                :hint="
                  enableConditionChange
                    ? 'ไม่สามารถเปลี่ยนเงื่อนไขในคำถามที่มีคำตอบแล้ว'
                    : LastQuestion.type === 'quickReply' &&
                      condition_selected.conditiontype === 'fixtext'
                    ? 'สามารถสร้างเงื่อนไขด้วยการกดปุ่มตัวเลือกจากคำถามได้'
                    : undefined
                "
                :persistent-hint="
                  enableConditionChange ||
                  (LastQuestion.type === 'quickReply' &&
                    condition_selected.conditiontype === 'fixtext')
                "
              ></v-select>
            </v-card-text>
            <v-card-text>
              <Freetext
                v-if="condition_selected.conditiontype === 'freetext'"
                :freetext="freetext"
                :freetext_notmatch="freetext_notmatch"
                :Jump="Jump"
                :NextQuestion="NextQuestion"
              />
              <Fixtext
                v-if="condition_selected.conditiontype === 'fixtext'"
                :rawfixtext="fixtext"
                :fixtext_notmatch="fixtext_notmatch"
                :Jump="Jump"
                :NextQuestion="NextQuestion"
                :LastQuestion="LastQuestion"
                @fixtextchange="CombineFixtext"
                ref="fixtext"
              />
              <Number
                v-if="condition_selected.conditiontype === 'number'"
                :number="number"
                :number_notmatch="number_notmatch"
                :Jump="Jump"
                :NextQuestion="NextQuestion"
              />
              <MultiSelect
                v-if="condition_selected.conditiontype === 'multiselect'"
                :rawmultiselect="multiselect"
                :Jump="Jump"
                :NextQuestion="NextQuestion"
                :LastQuestion="LastQuestion"
                @multiselectchange="CombineMultiSelect"
                ref="multiselect"
              />
            </v-card-text>
          </v-card>
        </v-expand-transition>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Freetext from "./Freetext";
import Fixtext from "./Fixtext";
import Number from "./Number";
import MultiSelect from "./MultiSelect";
export default {
  props: [
    "editable",
    "questioninfo",
    "JumpQuestion",
    "freetext",
    "fixtext",
    "number",
    "multiselect",
    "condition_selected",
    "freetext_notmatch",
    "fixtext_notmatch",
    "number_notmatch",
    "NextQuestion",
    "enableConditionChange",
  ],
  components: { Freetext, Fixtext, Number, MultiSelect },
  watch: {
    editable(newValue) {
      if (newValue) {
        this.collapse = true;
      }
    },
  },
  data() {
    return {
      collapse: false,
      conditiontypeitem: [
        {
          text: "คำบรรยาย",
          value: "freetext",
        },
        {
          text: "ตัวเลือก",
          value: "fixtext",
        },
        {
          text: "ตัวเลข",
          value: "number",
        },
        {
          text: "เลือกได้มากกว่า 1 คำตอบ",
          value: "multiselect",
        },
      ],
    };
  },
  computed: {
    Jump() {
      let allownext;
      if (this.JumpQuestion) {
        let allnext = [...this.JumpQuestion.connect, ...this.JumpQuestion.end];
        allownext = allnext.filter(
          (qid) => qid.questionID !== this.questioninfo.questionID
        );
        return allownext;
      }
      return [];
    },
    LastQuestion() {
      if (this.questioninfo) {
        let lastquestion =
          this.questioninfo.questions[this.questioninfo.questions.length - 1];
        if (lastquestion) {
          return lastquestion;
        }
      }
      return "";
    },
  },
  methods: {
    RestoreFixtext(tempfixtext, lastqType) {
      if (this.condition_selected.conditiontype === "fixtext") {
        this.$refs.fixtext.RestoreCond(tempfixtext, lastqType);
      }
    },
    CombineFixtext(data) {
      this.$emit("fixtext-setdata", data);
    },
    RestoreMultiSelect(tempmulti, lastqType) {
      if (this.condition_selected.conditiontype === "multiselect") {
        this.$refs.multiselect.RestoreCond(tempmulti, lastqType);
      }
    },
    CombineMultiSelect(data) {
      // console.log("CombineMultiSelect", data);
      this.$emit("multiselect-setdata", data);
    },
    QuestionTextShow(question) {
      switch (question.type) {
        case "image": {
          return "รูปภาพ";
        }
        case "video": {
          return "วิดิโอ";
        }
        default: {
          return question.text;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
